import { useSolicitacoesExameUnpagedQuery } from 'graphql/hooks.generated'
import SolicitacaoExamesTable from 'view/atendimentos/detail/soap/plano/exames/ExamesTable'
import { joinSolicitacoesExame } from 'view/atendimentos/detail/soap/plano/exames/utils-solicitacaoExames'

import { LotacaoFolhaRosto } from '../../model'

interface SolicitacoesExamesFolhaRostoProps {
  atendimentoProfissionalId: ID
  prontuarioId: ID
  atendimentoId: ID
  cidadaoId: ID
  dataReferencia: Instant
  lotacao: LotacaoFolhaRosto
}

export const SolicitacoesExamesFolhaRosto = (props: SolicitacoesExamesFolhaRostoProps) => {
  const { atendimentoProfissionalId, prontuarioId, atendimentoId, cidadaoId, dataReferencia, lotacao } = props

  const {
    data: { solicitacoesExame },
    loading,
  } = useSolicitacoesExameUnpagedQuery({
    variables: {
      input: {
        prontuarioId,
      },
    },
  })

  const convertedItems = joinSolicitacoesExame(solicitacoesExame?.content, [])

  return (
    <SolicitacaoExamesTable
      atendimentoProfissionalId={atendimentoProfissionalId}
      atendimentoId={atendimentoId}
      prontuarioId={prontuarioId}
      dataReferencia={dataReferencia}
      lotacao={lotacao}
      loading={loading}
      cidadaoId={cidadaoId}
      items={convertedItems}
      readOnly
    />
  )
}
